// SHO-51: shared "has the user customized their showcase?" predicate.
// Both the Profile page's right-side card and the Feed page's
// "Complete your showcase page" banner read from this so they can never
// disagree. Lenient by design — any single saved showcase field flips it
// true. Basic-profile fields (e.g. users.location, full_name) intentionally
// don't count; this is strictly about the showcase artifact.
export function hasShowcaseContent(fullProfile) {
  if (!fullProfile) return false;
  const performer = fullProfile.performer || {};
  return Boolean(
    (Array.isArray(fullProfile.media) && fullProfile.media.length > 0) ||
      (fullProfile.credits && Object.keys(fullProfile.credits).length > 0) ||
      (fullProfile.skills && Object.keys(fullProfile.skills).length > 0) ||
      (Array.isArray(fullProfile.links) && fullProfile.links.length > 0) ||
      (Array.isArray(fullProfile.professions) && fullProfile.professions.length > 0) ||
      performer.display_name ||
      performer.tagline ||
      performer.bio ||
      performer.job_title ||
      performer.contact_blurb
  );
}
